export const GET_ALL_REDFLAGGED = 'GET_ALL_REDFLAGGED'
export const GET_ALL_REDFLAG_RESOLVED = 'GET_ALL_REDFLAG_RESOLVED'
export const GET_REDFLAG_FLAGGEDBY = 'GET_REDFLAG_FLAGGEDBY'
export const GET_REDFLAG_RESOLVEDBY = 'GET_REDFLAG_RESOLVEDBY'
